import { io } from 'socket.io-client';

const URL = process.env.REACT_APP_SOCKET_IO_URL ?? 'http://localhost:8081';

const localStorageUser = localStorage.getItem('user');
const user = localStorageUser ? JSON.parse(localStorageUser) : null;

const socket = io(URL, { auth: { accessToken: user?.accessToken } });

socket.on('connect_error', (err: any) => {
    console.error(err.message);
});

export default socket;
